import React, { useState, useEffect } from 'react';
import { getAllArtworks } from '../data/artworkData';

const GalleryPage = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  // Get all artworks
  const allArtworks = getAllArtworks();

  return (
    <div className="min-h-screen bg-gray-50 pt-20 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">Art Gallery</h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Explore our complete collection of artwork, from portraits to landscapes, 
            each piece crafted with passion and attention to detail.
          </p>
        </div>

        {/* Artwork Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {allArtworks.map((artwork, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer"
              onClick={() => setSelectedImage(artwork)}
            >
              <div className="aspect-square">
                <img
                  src={artwork.image || artwork}
                  alt={artwork.title || `Artwork ${index + 1}`}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                  onError={(e) => {
                    e.target.src = '/images/placeholder.jpg'; // Fallback image
                  }}
                />
                {/* Location Overlay - Only visible when location exists */}
                {artwork.location && artwork.location !== 'Location: [To be updated]' && artwork.location.trim() !== '' && (
                  <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-70 text-white px-2 py-1">
                    <p className="text-xs font-medium truncate">📍 {artwork.location}</p>
                  </div>
                )}
              </div>
              <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-50 transition-all duration-300 flex items-end">
                <div className="p-4 text-white transform translate-y-full group-hover:translate-y-0 transition-transform duration-300 mb-6">
                  <h3 className="font-semibold text-lg mb-1">{artwork.title || `Artwork ${index + 1}`}</h3>
                  {artwork.medium && <p className="text-sm opacity-90">{artwork.medium}</p>}
                  {artwork.size && <p className="text-sm opacity-75">{artwork.size}</p>}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* No results message */}
        {allArtworks.length === 0 && (
          <div className="text-center py-12">
            <p className="text-gray-500 text-lg">No artworks found.</p>
          </div>
        )}
      </div>

      {/* Modal for enlarged image */}
      {selectedImage && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <div className="relative max-w-4xl max-h-full">
            <button
              onClick={() => setSelectedImage(null)}
              className="absolute -top-12 right-0 text-white hover:text-gray-300 text-4xl font-light"
            >
              ×
            </button>
            <img
              src={selectedImage.image || selectedImage}
              alt={selectedImage.title || 'Artwork'}
              className="max-w-full max-h-[80vh] object-contain"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-75 text-white p-4">
              <h3 className="text-xl font-semibold mb-2">{selectedImage.title || 'Artwork'}</h3>
              {selectedImage.medium && <p className="text-sm opacity-90 mb-1">{selectedImage.medium}</p>}
              {selectedImage.size && <p className="text-sm opacity-75">{selectedImage.size}</p>}
              {selectedImage.location && selectedImage.location !== 'Location: [To be updated]' && selectedImage.location.trim() !== '' && (
                <p className="text-sm text-yellow-300 font-medium">📍 {selectedImage.location}</p>
              )}
              {selectedImage.description && (
                <p className="text-sm mt-2 opacity-90">{selectedImage.description}</p>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GalleryPage;
